import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Center } from "./center.model";

@Injectable({
  providedIn: 'root'
})
export class CenterService {

  selectedCenter: Center;
  CenterList: Center[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDCenter(center: Center) {

    console.log(center);
    let body = center;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Center/IUD', body, { headers: headers });
  }

  GetCollectionTypeList() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/CollectionType', body, { headers: headers });
  }

  FetchCenterByCenterId(center) {

    let body = center;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Center/Fetch', body, { headers: headers });
  }


  //-----------------------------FetchCenterList----Component-------------------------------------
  FetchCenterList() {

    this.selectedCenter = new Center();
    this.selectedCenter.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCenter.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenter.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCenter.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Center/FetchList', body, { headers: headers });
  }

  GetBranchList() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Branch', body, { headers: headers });
  }

}
